exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toast-wrapper {\n  display: block;\n  width: 350px;\n  cursor: pointer;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #f1f1f1;\n  margin-bottom: 20px; }\n  .toast-wrapper.success {\n    background-color: #16ab39; }\n  .toast-wrapper.error {\n    background-color: #d01919; }\n  .toast-wrapper.warn {\n    background-color: #fbbd08; }\n  .toast-wrapper.info {\n    background-color: #1678c2; }\n  .toast-wrapper .toast-message {\n    padding: 10px; }\n  .toast-wrapper .toast-title {\n    font-weight: bold;\n    font-size: 10pt;\n    margin-bottom: 8px; }\n  .toast-wrapper .toast-content {\n    font-weight: normal;\n    font-size: 8pt; }\n  .toast-wrapper .toast-icon {\n    height: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    color: #f1f1f1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/luvi/frontend/src/app/shared/services/toast/toast.component.scss
// module id = ../../../../../src/app/shared/services/toast/toast.component.scss
// module chunks = main